<template>
    <div class='c_404'>
        <div class='pdt-100'>
            <img :src='defaultImg + netErrorImg' />
            <p>服务器开了个小差，请刷新页面</p>
            <mt-button size="small" plain type="danger" @click.native="handleClick">刷新</mt-button>
        </div>
    </div>
</template>
<script>
import { IMG_BASE_URL, BASE_HREF } from '../config/index'

export default {
  data () {
    return {
      defaultImg: IMG_BASE_URL,
      netErrorImg: '/upaiyun/Sys/20180808/4933860415081273405.png'
    }
  },
  methods: {
    handleClick () {
      window.location.href = BASE_HREF
    }
  }
}
</script>
<style scoped>
  div {
    margin: 0;
    padding: 0;
    border: 0;
  }
  p {
    margin: 0;
    padding: 0
  }
  .c_404{
    width: 100%;
    height: 100%;
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    background-color: #ffffff;
  }
  .pdt-100{
    padding-bottom: 100px;
  }
  .c_404 img{
    width:50%;
  }
  .c_404 p{
    margin:20px 0 60px 0;
    color: #888;
  }
  .c_404 button{
    border-radius: 16.5px;
    width:80px;
  }
</style>
